<template>
  <draggable
    tag="div"
    :list="list"
    :group="{ name: `depth_${depth}`, put: false }"
    :disabled="isSelect || depth > 2"
    handle=".btnHandle"
    animation="300"
    class="categoryTree">
    <div
      v-for="item in list"
      :key="item.categoryId"
      class="item">
      <div class="itemWrap">
        <div class="itemInfo">
          <button
            v-if="item.subCategory && item.subCategory.length"
            type="button"
            class="btnFold"
            @click="foldItem(item.categoryId)"></button>
          <div v-if="isSelect && !(item.subCategory && item.subCategory.length)" class="checkbox">
            <input
              type="checkbox"
              :id="`check_category_${item.categoryId}`"
              :value="item.categoryId"
              v-model="checked" />
            <label :for="`check_category_${item.categoryId}`"></label>
          </div>
          <SetLanguageValue class="categoryName"
            :locale="locale"
            :langValue="item.categoryLabel"
            :disabled="isSelect" />
          <button
            v-if="!isSelect && !(item.subCategory && item.subCategory.length)"
            type="button"
            class="btnSetting"
            @click="setItem(item.categoryId)"></button>
          <button
            v-if="!isSelect && depth < 2"
            type="button"
            class="btnAdd"
            @click="addChildren(item)"></button>
          <button
            v-if="!isSelect"
            type="button"
            class="btnDel"
            @click="removeItem(item.categoryId)"></button>
        </div>
        <button
          v-if="!isSelect"
          type="button"
          class="btnHandle"></button>
      </div>
      <ShopCategoryTree
        v-if="item.categoryId !== 'call-staff' && item.subCategory && item.subCategory.length && !foldItems.includes(item.categoryId)"
        :locale="locale"
        :list="item.subCategory"
        :defaultLang="defaultLang"
        :isSelect="isSelect"
        :checkedIds="checkedIds"
        :depth="depth + 1"
        :class="{childrenGroup: depth > 1}"
        @addChildren="addChildren"
        @setItem="setItem"
        @removeItem="removeItem"
        @setLanguage="setLanguage"
        @checkCategory="checkCategory" />
    </div>
    <div v-if="isSelect && depth === 1" class="item callStaffItem">
      <div class="itemWrap">
        <div class="itemInfo">
          <div class="checkbox">
            <input
              type="checkbox"
              id="check_category_call-staff"
              value="call-staff"
              v-model="checked" />
            <label for="check_category_call-staff"></label>
          </div>
          <div class="categoryName">{{ locale['call-staff'] }}</div>
        </div>
      </div>
    </div>
  </draggable>
</template>

<script>
import { mapGetters } from 'vuex'
import draggable from 'vuedraggable'
import LANG from '@/common/lang'
import regExp from '@/common/regExp'
import UNIQUE from '@/common/unique'
import SetLanguageValue from '@/components/Util/SetLanguageValue'

export default {
  name: 'ShopCategoryTree',
  props: {
    locale: Object,
    list: Array,
    defaultLang: String,
    isBaseShopPos: {
      type: Boolean,
      default: false
    },
    isSelect: {
      type: Boolean,
      default: false
    },
    checkedIds: {
      type: Array,
      default: () => []
    },
    depth: {
      type: Number,
      default: 1,
    }
  },
  components: {
    draggable,
    SetLanguageValue
  },
  computed: {
    checked: {
      get () {
        return this.checkedIds
      },
      set (ids) {
        this.checkCategory(ids)
      }
    }
  },
  data () {
    return {
      foldItems: []
    }
  },
  methods: {
    checkCategory (ids) {
      this.$emit('checkCategory', ids)
    },
    setLanguage (categoryId, categoryLabel) {
      this.$emit('setLanguage', categoryId, categoryLabel)
    },
    itemClass (item) {
      return this.list.includes(item) ? 'item' : 'childrenItem'
    },
    addChildren (item) {
      if (!item.subCategory) {
        this.$set(item, 'subCategory', [])
      }
      if (this.depth < 2) {
        item.subCategory.push({
          categoryId: UNIQUE.uniqueId8(),
          categoryLabel: LANG.valueObj('')
        })
      }
    },
    removeItem (categoryId) {
      // this.list.splice(index, 1)
      this.$emit('removeItem', categoryId)
    },
    setItem (categoryId) {
      this.$emit('setItem', categoryId)
    },
    foldItem (categoryId) {
      function toggleItem(arr, item) {
        const index = arr.indexOf(item)
        if (index !== -1) {
          arr.splice(index, 1)
        } else {
          arr.push(item)
        }
        return arr
      }
      this.foldItems = toggleItem(this.foldItems, categoryId)
    }
  }
}
</script>

<style lang="scss" scoped>
.categoryTree {
  .item {
    margin-bottom: 8px;
    .categoryTree {
      margin-left: 24px;
      .item {
        margin-top: 2px;
        margin-bottom: 0;
      }
    }
  }
  .itemWrap {
    display: flex;
  }
  .btnHandle {
    position: relative;
    width: 36px;
    border: 1px solid $color-lgrey2;
    border-left: none;
    border-radius: 0 4px 4px 0;
    background: $bg-default;
    cursor: move;
    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: url('~@/assets/img/move.png') 50% 50% / 16px no-repeat;
      opacity: 0.2;
    }
  }
  .itemInfo {
    flex: 1;
    display: flex;
    align-items: center;
    padding: 0 0 0 12px;
    border: 1px solid $color-lgrey2;
    border-radius: 4px 0 0 4px;
    button {
      width: 36px;
      height: 36px;
      font-size: 0;
      &:before {
        content: "";
        display: block;
        width: 100%;
        height: 100%;
        background: url('~@/assets/img/ico_arrow.svg') 50% 50% / 16px no-repeat;
        opacity: 0.4;
      }
      &.btnSetting:before {
        background-image: url('~@/assets/img/ico_setting.svg');
        background-size: 24px;
      }
    }
    .checkbox {
      margin-right: 8px;
      [disabled] + label {
        opacity: 0.6;
      }
    }
    .name {
      flex: 1;
    }
    .btnFold {
      &:before {
        background-image: url('~@/assets/img/ico_arrow.svg');
      }
    }
    .btnAdd {
      height: 40px;
      border: 1px dashed $color-lgrey2;
      border-radius: 4px;
      background-color: $bg-default;
      &:before {
        background-image: url('~@/assets/img/ico_plus.svg');
        opacity: 0.2;
      }
    }
    .btnDel {
      height: 100%;
      &:before {
        background: url('~@/assets/img/ico_close_black.svg') calc(100% - 8px) 8px / 16px no-repeat;
        opacity: 0.2;
      }
    }
    .categoryName {
      flex: 1;
      margin: 4px;
    }
  }
  .callStaffItem {
    margin-top: 20px;
    .categoryName {
      padding-top: 0.8em;
      padding-bottom: 0.8em;
    }
  }
}
</style>
